import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import PrivateRoute from "./components/shared/PrivateRoute";
import { AuthProvider } from "./components/shared/AuthContext";
import Customers from "./pages/Customers/Customers";
import AddEditCustomer from "./pages/Customers/AddEditCustomer";
import EntityDetails from "./pages/EntityDetails";
import AddEditEntityDetails from "./pages/AddEditEntityDetails";
import Permissions from "./pages/Permissions";
import BusinessLoan from "./pages/Loans/BusinessLoan";
import AddEditBusinessLoan from "./pages/Loans/AddEditBusinessLoan";
import Reports from "./pages/Reports/Reports";
import AccountStatement from "./pages/Reports/AccountStatement";
import Memberdetails from "./pages/Memberdetails";
import TransactionPDF from "./pages/Reports/TransactionPDF";

import "./index.css";
import AccountsCreation from "./pages/AccountsCreation";
import "@fortawesome/fontawesome-free/css/all.min.css";
import DailyCollectionReport from "./pages/Reports/DailyCollectionReport";
import DisbursedAmountReport from "./pages/Reports/DisbursedAmountReport";
import CroCollectionsReport from "./pages/Reports/CroCollectionsReport";
import LoanDemand from "./pages/Reports/LoanDemand";

import DayEndProcess from "./pages/Dayendprocess";
import DayEndProcessV2 from "./pages/DayendprocessV2";
import SavingsReport from "./pages/Reports/SavingsReport";
import UploadMembers from "./pages/Excel";
import UploadAccountStatement from "./pages/Uploadaccount";
import Chitfund from "./pages/Chitfund";
import FixedDeposit from "./pages/FixedDeposit"
import Swapingfiledofficer from "./pages/Swapingfiledofficer";
import DepositeandWithdraw_report from "./pages/Reports/DepositeandWithdraw_report";
import SFU_report from "./pages/Reports/SFU_report";
import Demand_collection_report from "./pages/Reports/Demand_collection_report";
import Ledger_section from "./pages/Ledger_section";
import BalanceBook from "./pages/BalanceBook";
import AccountGroup from "./pages/AccountGroup";
import LedgerGroup from "./pages/LedgerGroup";
import LedgerReport from "./pages/Reports/LedgerReport";
import Receipts from "./pages/Receipts/Receipts";
import Payments from "./pages/Payments/Payments";
import BalanceSheet from "./pages/Balancesheet"; // capital S matches file
import FutureDemandReport from "./pages/Reports/FutureDemandReport";
import OverdueReport from "./pages/Reports/OverdueReport";
import PARReport from "./pages/Reports/PARReport";
import SecurityDepositReport from "./pages/Reports/SecurityDepositReport";
import InterestReport from "./pages/Reports/InterestReport";
import ForeclosureReport from "./pages/Reports/ForeclosureReport";
import LoanOutstandingReport from "./pages/Reports/LoanOutstandingReport";
import MasterDataReport from "./pages/Reports/MasterDataReport";




const entities = [
  { path: "branches", label: "branches", addEditPath: "addEditBranch" },
  { path: "centers", label: "centers", addEditPath: "addEditCenter" },
  { path: "roles", label: "roles", addEditPath: "addEditRole" },
  { path: "staff", label: "staff", addEditPath: "addEditStaff" },
  { path: "accounts", label: "accounts", addEditPath: "addEditAccount" },
  { path: "deposits", label: "deposits", addEditPath: "addEditDeposit" },
  {
    path: "withdrawals",
    label: "Withdrawals",
    addEditPath: "addEditWithdraw",
  },
  {
    path: "funding-agencies",
    label: "funding_agencies",
    addEditPath: "addEditFundingAgency",
  },
];

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Login />} />




          {/* Private Routes */}
          <Route element={<PrivateRoute />}>
            <Route path="/uploadmemberdetails" element={<UploadMembers />} />
            <Route path="/dayendprocess" element={<DayEndProcess />} />
            {/* Redesigned layout, running in parallel. The original page above is
                untouched; retire one once the other is trusted. */}
            <Route path="/dayendprocess-v2" element={<DayEndProcessV2 />} />
            <Route path="/uploadaccount" element={<UploadAccountStatement />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/AccountStatement" element={<AccountStatement />} />
            <Route path="/memberdetails" element={<Memberdetails />} />
            <Route path="/transaction-pdf" element={<TransactionPDF />} />
            {/* Report */}
            <Route path="/daily-report" element={<Reports />} />
            <Route path="/DailyCollectionReport" element={<DailyCollectionReport />} />
            <Route path="/DisbursedAmountReport" element={<DisbursedAmountReport />} />
            <Route path="/CroCollectionsReport" element={<CroCollectionsReport />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/addEditCustomer" element={<AddEditCustomer />} />
            <Route path="/permissions" element={<Permissions />} />
            <Route path="/businessLoan" element={<BusinessLoan />} />
            <Route path="/loandemandreport" element={<LoanDemand />} />
            <Route path="/Chitfund" element={<Chitfund />} />
            <Route path="/fixeddeposite" element={<FixedDeposit />} />
            <Route path="/savingsreport" element={<SavingsReport />} />
            <Route path="/demand_collection_report" element={<Demand_collection_report />} />
            <Route path="/sfu_report" element={<SFU_report />} />
            <Route path="/depositeandwithdraw_report" element={<DepositeandWithdraw_report />} />
            <Route path="/swaping_field_officer" element={<Swapingfiledofficer />} />
            <Route path="/ledger_section" element={<Ledger_section />} />
            <Route path="/balance-book" element={<BalanceBook />} />
            <Route path="/accountGroup" element={<AccountGroup />} />
            <Route path="/ledgerGroup" element={<LedgerGroup />} />
            <Route path="/ledgerReport" element={<LedgerReport />} />
            <Route path="/receipts" element={<Receipts />} />
            <Route path="/payments" element={<Payments />} />
            <Route path="/balance-sheet" element={<BalanceSheet />} />
            {/* New Report Pages */}
            <Route path="/future-demand-report" element={<FutureDemandReport />} />
            <Route path="/overdue-report" element={<OverdueReport />} />
            <Route path="/par-report" element={<PARReport />} />
            <Route path="/security-deposit-report" element={<SecurityDepositReport />} />
            <Route path="/interest-report" element={<InterestReport />} />
            <Route path="/foreclosure-report" element={<ForeclosureReport />} />
            <Route path="/loan-outstanding-report" element={<LoanOutstandingReport />} />
            <Route path="/master-data-report" element={<MasterDataReport />} />










            {/* dummy creation */}
            <Route path="/accountcreation" element={<AccountsCreation />} />
            <Route
              path="/addEditBusinessLoan"
              element={<AddEditBusinessLoan />}
            />


            {/* Dynamic Entity Routes */}
            {entities.map(({ path, label, addEditPath }) => (
              <Route key={path}>
                <Route
                  path={`/${path}`}
                  element={<EntityDetails entity={label} />}
                />
                <Route
                  path={`/${addEditPath}`}
                  element={<AddEditEntityDetails />}
                />
              </Route>
            ))}
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
